export const lang = {

	//สาธารณะ
	common: {
		//ชื่อชุดภาษา
		name: 'อังกฤษ'
	}
}
